var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tf-badge",class:[
    { 'is-solid': _vm.isSolid },
    { 'is-pill': _vm.isPill },
    { 'is-counter': _vm.isCounter },
    `is-${_vm.size} is-${_vm.status}`,
  ],domProps:{"textContent":_vm._s(_vm.value)}})
}
var staticRenderFns = []

export { render, staticRenderFns }